import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagTZ = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#000",
  d: "M7.321 42.678a25.148 25.148 0 0 0 3.342 2.807l34.821-34.82a25.15 25.15 0 0 0-6.149-6.149l-34.82 34.82a25.166 25.166 0 0 0 2.806 3.342Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#6DA544",
  d: "M7.323 7.322c-7.887 7.887-9.401 19.732-4.546 29.14L36.463 2.777C27.054-2.08 15.21-.565 7.323 7.322Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#338AF3",
  d: "M42.678 42.678c7.886-7.887 9.4-19.732 4.545-29.14L13.537 47.222c9.408 4.856 21.253 3.342 29.14-4.545Z"
}));
FlagTZ.displayName = 'FlagTZ';
export default withFlagWrapper(FlagTZ);
//# sourceMappingURL=index.js.map